export default "__VITE_ASSET__rZwYBlqG__"